import React from 'react';
import { additionalProjects, personalProjects } from '../../data/portfolio';

const ProjectCard = ({ project }) => (
  <article className={project.featured ? 'personal-card is-featured' : 'personal-card'}>
    <div className="project-media project-system" role="img" aria-label={`${project.title} workflow: ${project.workflow.join(' to ')}`}>
      <span className="media-index">{project.number} / PERSONAL PROJECT</span>
      <div className="project-system-inner">
        <span className="project-system-label">HIGH-LEVEL WORKFLOW</span>
        <div className="project-system-stages">
          {project.workflow.map((step, index) => <div className="project-system-stage" key={step}><span>{String(index + 1).padStart(2, '0')}</span><strong>{step}</strong></div>)}
        </div>
      </div>
    </div>
    <div className="personal-content">
      <p className="card-category">{project.category}</p>
      <h3>{project.title}</h3>
      <div className="project-story"><div><span>THE PROBLEM</span><p>{project.problem}</p></div><div><span>THE SOLUTION</span><p>{project.solution}</p></div></div>
      <p className="project-contribution"><strong>My contribution.</strong> {project.contribution}</p>
      <div className="tag-list">{project.stack.map((tech) => <span className="tag" key={tech}>{tech}</span>)}</div>
      {project.source && <a className="text-link" href={project.source} target="_blank" rel="noopener noreferrer" data-analytics-event="project_source">View source repository <span aria-hidden="true">↗</span></a>}
    </div>
  </article>
);

const Projects = () => (
  <section className="section projects-section" id="projects" aria-labelledby="projects-title">
    <div className="shell">
      <div className="section-heading section-heading-row"><div><span className="section-number">04 / PERSONAL PROJECTS</span><h2 id="projects-title">Ideas built end to end.</h2></div><p>Independent work across agentic healthcare, retrieval, forecasting, and predictive maintenance.</p></div>
      <div className="personal-grid">{personalProjects.map((project) => <ProjectCard key={project.title} project={project} />)}</div>
      <div className="earlier-work"><span className="mono">EARLIER WORK</span>{additionalProjects.map((project) => <div key={project.title}><p><strong>{project.title}</strong> — {project.summary}</p><a className="text-link" href={project.source} target="_blank" rel="noopener noreferrer" data-analytics-event="project_source">Source <span aria-hidden="true">↗</span></a></div>)}</div>
    </div>
  </section>
);

export default Projects;
